import { fetchApi } from "containers/helpers";

export const getFreelanceGodsons = (userId) => fetchApi('/godsons/'+userId)

export const sentFundsToFreelance = userId => fetchApi('/godfather/paymentSent/'+userId, {
    method: 'PATCH'
})